import { Box, styled } from '@mui/material';

// A box that takes all available space, and allows its content to do the same
export const FillingBox = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
});
